import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  GetTherapistSlotsAvailabilityModeEnum,
  GroupVisitControllerApi,
} from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

export const THERAPIST_SLOTS_QUERY_KEY = "group-visit-therapist-slots";

export type TherapistSlot = {
  duration: number;
  status: string;
  startTime: string;
  endTime: string;
  timeZone?: string;
};

type Params = {
  groupVisitId?: string;
  providerIds: string[];
  startDate?: string;
  endDate?: string;
  availabilityMode?: GetTherapistSlotsAvailabilityModeEnum;
  locationUuid?: string;
  /** Slot length in minutes; the group's session duration. */
  duration?: number;
  enabled?: boolean;
};

/**
 * Open slots of the group's therapists. With the primary and co-therapist
 * both passed, only the slots where both are free come back.
 */
export const useTherapistSlots = ({
  groupVisitId,
  providerIds,
  startDate,
  endDate,
  availabilityMode,
  locationUuid,
  duration,
  enabled = true,
}: Params) =>
  useQuery({
    queryKey: [
      THERAPIST_SLOTS_QUERY_KEY,
      groupVisitId,
      providerIds,
      startDate,
      endDate,
      availabilityMode,
      locationUuid,
      duration,
    ],
    enabled:
      enabled &&
      !!groupVisitId &&
      providerIds.length > 0 &&
      !!startDate &&
      !!endDate,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new GroupVisitControllerApi(getConfigObject())
        .getTherapistSlots(
          groupVisitId as string,
          providerIds,
          startDate,
          endDate,
          availabilityMode,
          locationUuid,
          duration,
          getXtenantId()
        )
        .then((res) => (res?.data?.data ?? []) as TherapistSlot[]),
  });
